/* src/modules/create_tutor/cards/CreateTutorCard/styles.js */

export default theme => {
  const { unit } = theme.spacing;
  const space = unit * 3;
  return {
    paper: {
    },
    message: {
      marginTop: space,
    },
    formControl: {
      margin: space,
      marginBottom: 0,
    },
    messageContainer: {
      padding: space,
    },
    group: {
      margin: `${unit}px 0`,
    },
    body: {
      padding: space,
    },
    input: {
      width: '40%',
    },
    secondTitle: {
      marginTop: space,
    },
    title: {
      marginBottom: unit * 2,
      marginLeft: space,
      marginRight: space,
    },
    deliveryForm: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
    },
    nameFields: {
      display: 'flex',
      width: '100%',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginTop: theme.spacing.unit,
    },
    sendIcon: {
      marginLeft: unit,
    },
    alarmIcon: {
      marginRight: unit,
    },
    button: {
      marginLeft: 'auto',
    },
    buttonContainer: {
      display: 'flex',
    },
    coursesInput: {
      flex: 1,
      marginBottom: theme.spacing.unit * 3,
    },
    adornment: {
      bottom: 8,
    },
    instructions: {
      marginLeft: space * 2,
      marginRight: space * 2,
    },
    padding: {
      padding: space,
    },
  };
};



// WEBPACK FOOTER //
// ./src/modules/create_tutor/cards/CreateTutorCard/styles.js